import { j as e } from "./atoms-v218.js";
import { forwardRef as G } from "react";
import { Wrapper as J, MediaWrapper as w, MediaLabel as L, ContentWrapper as Q, HeaderWrapper as T, BodyWrapper as U, FooterWrapper as X, CallToActionWrapper as Y, Body as Z, CallToAction as _, Footer as v, Header as rr, Subheader as er } from "./atoms-v2107.js";
import { isClickIgnored as F } from "./atoms-v2108.js";
import { SlotType as s, CardVariant as p } from "./atoms-v2109.js";
import { CardSkeleton as or } from "./atoms-v2110.js";
import { RenderSlot as d } from "./atoms-v2111.js";
import { Picture as tr } from "./atoms-v233.js";
import { useBreakpoints as nr } from "./atoms-v251.js";
const g = G(
  ({
    ariaLabel: k,
    bodyText: f,
    callToActionText: h,
    className: m,
    colorTheme: i = "light",
    disabled: A = !1,
    footerText: C,
    headerText: $,
    id: D,
    isSkeleton: I = !1,
    mediaAlt: M,
    mediaLabel: l,
    mediaSrc: j,
    onClick: o,
    renderBody: b,
    renderCallToAction: x,
    renderFooter: y,
    renderHeader: S,
    renderMedia: B,
    renderSubHeader: R,
    slotProps: H = {},
    subheaderText: E,
    variant: r = p.Standard,
    withBorder: K = !1
  }, P) => {
    const { current: t } = nr(), n = { colorTheme: i, variant: r }, a = {
      bodyText: f,
      callToActionText: h,
      footerText: C,
      headerText: $,
      mediaAlt: M,
      mediaLabel: l,
      mediaSrc: j,
      subheaderText: E
    };
    function z(c) {
      F(o) || o(c);
    }
    function N(c) {
      c.key === "Enter" && !F(o) && o(c);
    }
    const O = !!j || !!B, V = !!$ || !!S, W = !!f || !!b, u = !!C || !!y, q = !!h || !!x;
    return I ? /* @__PURE__ */ e.jsx(
      or,
      {
        className: m,
        hasBody: W,
        hasFooter: u,
        hasHeader: V,
        variant: r
      }
    ) : /* @__PURE__ */ e.jsxs(
      J,
      {
        $colorTheme: i,
        $isDisabled: A,
        $isLinked: !!o,
        $variant: r,
        $withBorder: K,
        "aria-label": k,
        className: m,
        "data-testid": "card-wrapper",
        id: D,
        onClick: z,
        ref: P,
        ...o ? {
          onKeyDown: N,
          role: "button",
          tabIndex: 0
        } : {},
        children: [
          O && /* @__PURE__ */ e.jsxs(
            w,
            {
              $variant: r,
              children: [
                d(s.Media)({
                  contentProps: a,
                  currentBreakpoint: t,
                  renderCb: B,
                  styleProps: n
                }),
                l && [p.Feature, p.Standard].includes(r) && /* @__PURE__ */ e.jsx(L, { $colorTheme: i, children: l })
              ]
            }
          ),
          H.picture && /* @__PURE__ */ e.jsx(w, { $variant: r, children: /* @__PURE__ */ e.jsx(
            tr,
            {
              ...H.picture
            }
          ) }),
          /* @__PURE__ */ e.jsxs(Q, { $variant: r, children: [
            /* @__PURE__ */ e.jsxs(T, { $variant: r, children: [
              d(s.Header)({
                contentProps: a,
                currentBreakpoint: t,
                renderCb: S,
                styleProps: n
              }),
              d(s.SubHeader)({
                contentProps: a,
                currentBreakpoint: t,
                renderCb: R,
                styleProps: n
              })
            ] }),
            (W || u) && /* @__PURE__ */ e.jsxs(U, { $colorTheme: i, $variant: r, children: [
              d(s.Body)({
                contentProps: a,
                currentBreakpoint: t,
                renderCb: b,
                styleProps: n
              }),
              u && /* @__PURE__ */ e.jsx(X, { $variant: r, children: d(s.Footer)({
                contentProps: a,
                currentBreakpoint: t,
                renderCb: y,
                styleProps: n
              }) })
            ] }),
            q && [p.Horizontal, p.Standard].includes(r) ? /* @__PURE__ */ e.jsx(Y, { $colorTheme: i, $variant: r, children: d(s.CallToAction)({
              contentProps: a,
              currentBreakpoint: t,
              renderCb: x,
              styleProps: n
            }) }) : null
          ] })
        ]
      }
    );
  }
);
g.displayName = "Card";
const hr = Object.assign(g, {
  Body: Z,
  CallToAction: _,
  Footer: v,
  Header: rr,
  SubHeader: er
});
export {
  hr as Card
};
